module.exports = __webpack_public_path__ + "img/def-cover-2.2b1b4449.jpg";